import { Container, Text, Icon } from '@chakra-ui/react';
import { useSelector } from 'react-redux';

import Tooltip from '../Tooltip';

const SummaryPill = ({ icon, count, tooltip, ...props }) => {
    const { darkMode } = useSelector((state) => {
        return { ...state.settings };
    });

    return (
        // Anchored to the pill's right edge: the pills sit at the right of the
        // page, and a centred label wide enough to pass the viewport edge added
        // a horizontal scrollbar instead of being pulled back into view.
        <Tooltip label={tooltip} placement="bottom-end" hasArrow>
            <Container
                display="flex"
                alignItems="center"
                justifyContent="center"
                borderRadius={10}
                borderColor="#EEEEEE"
                borderWidth={1}
                borderStyle="solid"
                height="36px"
                width="75px"
                fontSize="10px"
                fontWeight={400}
                color={darkMode ? 'white' : 'black'}
                backgroundColor={darkMode ? 'black' : 'white'}
                padding="10px"
                {...props}>
                <Icon
                    as={icon}
                    boxSize={5}
                    color={darkMode ? 'white' : 'black'}
                />
                <Text marginLeft="5px" lineHeight={10}>
                    {count}
                </Text>
            </Container>
        </Tooltip>
    );
};

export default SummaryPill;
